import { useMemo } from "react";
import { DRINKING_VALUE_LIST } from "../common/constants";
import { randomHexColor } from "../common/utils";
import SpinningWheel from "./spinning-wheel";

const DrinkingWheel = () => {
  const data = useMemo(() => {
    return DRINKING_VALUE_LIST.map((item) => ({
      ...item,
      backgroundColor: randomHexColor(),
    }));
  }, []);
  return <SpinningWheel data={data} />;
};

export default DrinkingWheel;
